module.exports = __webpack_public_path__ + "static/media/1.c4327111.png";